var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.reCaptchaRequested)?_c('ReCaptchaWidget',{ref:"ReCaptchaWidget",attrs:{"show-modal":_vm.showReCaptchaModal},on:{"ready":_vm.reCaptchaWidgetReady}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }